// Module
var code = "<div html=\"{{ messages[0] }}\" class=\"gc-notification\"></div>";
// Exports
export default code;